var exports = {
  "p_": "GuildEventsModal.module__list___Y3pyN1",
  "Ie": "GuildEventsModal.module__empty___Y3pyN1",
  "Nr": "GuildEventsModal.module__card___Y3pyN1",
  "MY": "GuildEventsModal.module__cardHeader___Y3pyN1",
  "UU": "GuildEventsModal.module__name___Y3pyN1",
  "VD": "GuildEventsModal.module__live___Y3pyN1",
  "mI": "GuildEventsModal.module__meta___Y3pyN1",
  "h_": "GuildEventsModal.module__description___Y3pyN1",
  "o1": "GuildEventsModal.module__actions___Y3pyN1",
  "U9": "GuildEventsModal.module__count___Y3pyN1",
};

module.exports = exports;
